/**
 * 站点业务文件路径规范化（纯函数，便于单测）。
 * 避免把已带 /dev-api 的地址再次拼上 VUE_APP_BASE_API。
 */

export function stripApiBasePrefix(path, apiBase = '') {
  let value = String(path || '')
  if (!value) {
    return ''
  }
  const base = String(apiBase || '').trim()
  if (!base || /^https?:\/\//i.test(base)) {
    return value
  }
  const prefix = base.replace(/\/$/, '')
  if (!prefix) {
    return value
  }
  // 剥掉重复前缀：/dev-api/dev-api/profile/... → /profile/...
  while (value === prefix || value.startsWith(`${prefix}/`)) {
    value = value === prefix ? '/' : value.slice(prefix.length)
  }
  return value || '/'
}

/**
 * 将业务文件地址收成站内相对路径：/storage/files/{id} 或 /profile/... 或 /paleo/...
 * 外链（OSS 等）返回空串。
 */
export function toSiteRelativeFilePath(url, apiBase = '', ownOrigin = '') {
  const raw = String(url || '').trim()
  if (!raw) {
    return ''
  }
  if (!/^https?:\/\//i.test(raw)) {
    const relative = raw.startsWith('/') ? raw : `/${raw}`
    return stripApiBasePrefix(relative, apiBase)
  }
  try {
    const parsed = new URL(raw)
    if (ownOrigin && parsed.origin !== ownOrigin) {
      const absBase = String(apiBase || '')
      if (/^https?:\/\//i.test(absBase)) {
        if (parsed.origin !== new URL(absBase).origin) {
          return ''
        }
      } else {
        return ''
      }
    }
    let path = parsed.pathname || ''
    path = stripApiBasePrefix(path, apiBase)
    if (
      path.includes('/storage/files/')
      || path.startsWith('/profile/')
      || /\/paleo\/(cms|public-files|files)\//.test(path)
    ) {
      return `${path}${parsed.search || ''}`
    }
  } catch (e) {
    return ''
  }
  return ''
}

export function isStorageOrProfilePath(path) {
  const value = String(path || '')
  return /\/storage\/files\/\d+(?:$|[/?#])/.test(value) || value.startsWith('/profile/')
}
